import React, { Component } from 'react'
import { Collapse, Button, Icon } from 'antd'
import { search } from '@services/api'
import WeightPanel from './WeightPanel'
import weightsTexts from '@texts/weights'
import { inject, observer } from 'mobx-react'
import SearchWeightsHistory from '@components/Popup/SearchWeightsHistory'
const { Panel } = Collapse

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
export default class extends Component {
    constructor() {
        super()
        this.state = {
            searchTypes: [{ type: 'doctor', subType: 'keywords', attributes: { rank: 20, cover: 15, speciality: 65 } }]
        }
    }

    async componentDidMount() {
        let searchTypes = []
        let promises = this.state.searchTypes.map(async searchType => {
            let { type, subType } = searchType
            await search
                .getSearchWeights({ type, subType })
                .then(result => searchTypes.push(result.data.results.hits[0]._source))
        })
        await Promise.all(promises)
        this.setState({ searchTypes })
    }

    render() {
        return (
            <>
                <Collapse style={{ flexDirection: 'column' }} accordion>
                    {this.state.searchTypes.map((searchType, idx) => (
                        <Panel
                            key={idx}
                            header={weightsTexts[searchType.type] + ' - ' + weightsTexts[searchType.subType]}
                            extra={
                                <Button
                                    style={{ marginBottom: '0.5rem', height: '1.5rem' }}
                                    onClick={event => {
                                        event.stopPropagation()
                                        event.preventDefault()
                                        this.props.popupStore.togglePopup('searchWeightHistory', {
                                            ...searchType
                                        })
                                    }}
                                >
                                    <Icon type="eye" />
                                </Button>
                            }
                        >
                            <WeightPanel searchType={searchType} />
                        </Panel>
                    ))}
                </Collapse>
                <SearchWeightsHistory />
            </>
        )
    }
}
